import {
  type ProgramUserData,
  type ProgramUserUpdateInput,
  type ProgramUserUpdateSuccess,
  toResponseError,
} from '@terros/common'
import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useProgramCache } from './cache'

export function useUpdateProgramUsers(): UpdateHookResponse<ProgramUserUpdateInput, ProgramUserData[]> {
  const mutation = useTantalimMutation<ProgramUserUpdateInput, ProgramUserUpdateSuccess>({
    url: '/program/user/update',
  })
  const cache = useProgramCache()

  async function update(input: ProgramUserUpdateInput): Promise<ProgramUserData[]> {
    try {
      const { programUsers } = await mutation.mutateAsync(input)
      cache.clearUsers(input.programId)
      return programUsers
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
